// src/layouts/MainLayout.jsx
import ProfileAvatarsr from "../components/common/Avatar/ProfileAvatarsr";
import Header from "../components/common/Header";
import './MainLayout.css'

const MainLayout = ({ children, title }) => {
  return (
    <div className="main-layout">
      {/* Sidebar */}
      <aside className="sidebar">
        <ProfileAvatarsr />
      </aside>

      {/* Main content */}
      <div className="content-area">
        {/* Header */}
        <Header title={title} />
        {/* Page Content */}
        <main className="page-content">{children}</main>
      </div>
    </div>
  );
};

export default MainLayout;